import { useContext, useEffect, useState } from "react";

import moment from "moment";

import TimeZoneContext from "context/timeZone/timeZoneContext";
import { useDateTime } from "shared/hooks/useDateTime";

import { SCHEDULE_TASK_TYPE, ScheduledTimePayload } from "../../../types";

const useScheduleTime = (
    scheduleType: SCHEDULE_TASK_TYPE | null,
    change: (data: ScheduledTimePayload) => void
) => {
    const { currentTimeZone } = useContext(TimeZoneContext);

    const { startOfTime } = useDateTime();

    const INITIAL_VALUE = [24, 28];

    const [isInverted, setIsInverted] = useState(false);
    const [value, setValue] = useState(INITIAL_VALUE);

    const formatTime = (val: number) => {
        const startOfDay = startOfTime("day");
        const minutes = val * 30;

        return startOfDay.add(minutes, "minutes").format("LT");
    };

    const firstTimestamp = formatTime(value[0]);
    const secondTimeStamp = formatTime(value[1]);

    const fromDate = isInverted ? secondTimeStamp : firstTimestamp;
    const toDate = isInverted ? firstTimestamp : secondTimeStamp;

    useEffect(() => {
        setIsInverted(false);
        setValue(INITIAL_VALUE);
        // eslint-disable-next-line
    }, [scheduleType]);

    useEffect(() => {
        const getTime = (isStart: boolean) =>
            moment
                .tz(isStart ? fromDate : toDate, "LT", currentTimeZone)
                .utc()
                .format("LT");

        const start = getTime(true);
        const end = getTime(false);

        const startAsMinutes = moment.duration(start).asMinutes();
        const endAsMinutes = moment.duration(end).asMinutes();

        const durationAsMinutes =
            endAsMinutes > startAsMinutes
                ? endAsMinutes - startAsMinutes
                : 1440 - startAsMinutes + endAsMinutes;

        if (scheduleType === SCHEDULE_TASK_TYPE.ByTime) {
            change({ from: startAsMinutes, duration: durationAsMinutes });
        }

        // eslint-disable-next-line
    }, [scheduleType, value, fromDate, toDate, currentTimeZone]);

    const toggleInvertion = () => setIsInverted(!isInverted);

    const handleChange = (newValue: number[]) => {
        const [from, to] = newValue;
        to - from >= 4 && setValue(newValue);
    };

    return {
        isInverted,
        value,
        fromDate,
        toDate,
        toggleInvertion,
        handleChange
    };
};

export { useScheduleTime };
